import { createAction } from '@reduxjs/toolkit';

export const requestCreateProgramme = createAction('request/createProgramme');
export const requestViewAllProgrammes = createAction('request/viewAllProgrammes');
export const requestViewProgramme = createAction('request/viewProgramme');
export const requestUpdateProgramme = createAction('request/updateProgramme');
export const requestActivateProgramme = createAction('request/activeProgramme');
export const requestViewUnassignedMembers = createAction('request/viewUnassignedMembers');
export const requestDownloadTeamLeaderboardExcel = createAction('request/downloadTeamLeaderboardExcel');
export const requestSendMemberActivationCommunications = createAction('request/SendMemberActivationCommunications');
export const requestUploadMemberExcel = createAction('request/uploadMemberExcel');
